export interface VolumeSpec { name: string; description: string; size: number; }
export interface Volume {
  type: "omega/query-omega/volume/Volume";
  "app-id": string;
  "volume-id": string;
  "volume-spec": VolumeSpec;
}
export type VolumeMap = { [k: string]: Volume };
export const initVolumeMap: VolumeMap = {};
export const volumeName = (v: Volume | undefined): string => v?.["volume-spec"]?.name ?? "";
export const volumeSize = (v: Volume | undefined): number => v?.["volume-spec"]?.size ?? 0;

// Human "42Gi" <-> bytes. Units are binary (Mi=2^20, Gi=2^30, Ti=2^40) to match the UI regex.
const UNIT: Record<string, number> = { Mi: 2 ** 20, Gi: 2 ** 30, Ti: 2 ** 40 };
const HUMAN_RE = /^(\d+)(Mi|Gi|Ti)$/;
export const humanToBytes = (s: string): number | null => {
  const m = HUMAN_RE.exec(s.trim());
  return m ? Number(m[1]) * UNIT[m[2]] : null;
};
export const bytesToHuman = (b: number): string => {
  if (!b) return "";
  for (const u of ["Ti", "Gi", "Mi"] as const) {
    if (b % UNIT[u] === 0) return `${b / UNIT[u]}${u}`;
  }
  return `${b}`; // fallback: raw bytes (non-multiple)
};
export const newVolume = (config: {
  appId: string; volumeId: string; name: string; description?: string; size?: number;
}): Volume => {
  const { appId, volumeId, name, description = "", size = 0 } = config;
  return {
    type: "omega/query-omega/volume/Volume",
    "app-id": appId, "volume-id": volumeId,
    "volume-spec": { name, description, size },
  };
};
